import CifaAPI from 'api/cifa/cifa.api';
import { CifaStatusEnum } from 'enum/cifaStatus.enum';
import { authService } from 'services/auth/auth_service';
import { create } from 'zustand';

export interface AquisicaoDetalhe {
    nomeRazao: string;
    cnpj?: string;
    cpf?: string;
    valor: number;
}

export interface AquisicoesPorFonte {
    cnpj: AquisicaoDetalhe[];
    cpf: AquisicaoDetalhe[];
}

export interface RecursoFinanceiro {
    tipo: 'Programa' | 'Projeto' | 'Ação/Atividade';
    descricao: string;
    valor_orcado: number;
    valor_liquidado: number;
}

export interface ICifaForm {
    uuid: string | null;
    ano_referencia: number;
    institution_uuid: string;
    formulario_status: CifaStatusEnum;
    responsavel_uuid: string | null;

    // PASSO 1: CUMPRIMENTO DO TERMO ESCOLAR
    termo_escolar_pmaf_elaborado: boolean;
    termo_escolar_pmaf_validado_seaf_mt: boolean;
    termo_escolar_ato_normativo_publicado: boolean;
    termo_escolar_ato_normativo_uuid: string | null;
    termo_escolar_cmdrs_constituido: boolean;
    termo_escolar_atas_reunioes_uuid: string | null;

    // PASSO 2: ASSISTENCIA TECNICA
    assistencia_tecnica_beneficiarios_atendidos: number | null;
    assistencia_tecnica_ata_cmdrs_uuid: string | null;
    assistencia_tecnica_parceria_instituicao: boolean;
    assistencia_tecnica_parceria_beneficiarios_atendidos: number | null;

    // Parcerias de Assistência Técnica
    assistencia_tecnica_parceria_empaer: boolean;
    assistencia_tecnica_parceria_empaer_documento_uuid: string | null;
    assistencia_tecnica_parceria_empaer_relatorio_documento_uuid: string | null;

    assistencia_tecnica_parceria_instituicoes_ensino: boolean;
    assistencia_tecnica_parceria_instituicoes_ensino_documento_uuid: string | null;
    assistencia_tecnica_parceria_instituicoes_ensino_relatorio_documento_uuid: string | null;

    assistencia_tecnica_parceria_ongs: boolean;
    assistencia_tecnica_parceria_ongs_documento_uuid: string | null;
    assistencia_tecnica_parceria_ongs_relatorio_documento_uuid: string | null;

    assistencia_tecnica_parceria_outras: boolean;
    assistencia_tecnica_parceria_outras_nome: string | null;
    assistencia_tecnica_parceria_outras_documento_uuid: string | null;
    assistencia_tecnica_parceria_outras_relatorio_documento_uuid: string | null;
    assistencia_tecnica_documento_parceria_uuid: string | null;

    // PASSO 3: ALIMENTAÇÃO ESCOLAR
    alimentacao_af_recurso_pnae: number | string;
    alimentacao_af_recurso_estado: number | string;
    alimentacao_af_recurso_prefeitura: number | string;
    alimentacao_total_recurso_pnae: number | string;
    alimentacao_total_recurso_estado: number | string;
    alimentacao_total_recurso_prefeitura: number | string;
    alimentacao_ata_aprovacao_uuid: string | null;

    // PASSO 4: ALIMENTAÇÃO ESCOLAR AQUISIÇÕES
    aquisicoes_pnae_federal_detalhamento: AquisicoesPorFonte | null;
    aquisicoes_governo_estado_detalhamento: AquisicoesPorFonte | null;
    aquisicoes_prefeitura_detalhamento: AquisicoesPorFonte | null;

    // PASSO 5: RECURSO FINANCEIRO APLICADO
    recursos_financeiros_aplicados_detalhamento: RecursoFinanceiro[] | null;
    receita_corrente_liquida_2025: number | string | null;

    // ABA 6
    organizacoes_af_formulario_preenchido: boolean;

    // PREENCHIMENTO DAS ABAS
    status_aba_1: CifaStatusEnum;
    status_aba_2: CifaStatusEnum;
    status_aba_3: CifaStatusEnum;
    status_aba_4: CifaStatusEnum;
    status_aba_5: CifaStatusEnum;
    status_aba_6: CifaStatusEnum;

}

interface CifaStore {
    cifa: ICifaForm,
    loading: boolean,
    setCifa: (cifa: ICifaForm) => void,
    getCifa: (institution_uuid: string, year: number) => Promise<boolean>,
    setLoading: (loading: boolean) => void,
    setPartialForm: (chave: keyof ICifaForm, valor: any) => void,
}

const useCifaStore = create<CifaStore>((set) => ({
    cifa: {} as ICifaForm,
    listCifas: [] as ICifaForm[],
    loading: false,
    setCifa: (cifa: ICifaForm) => set({ cifa }),
    getCifa: async (institution_uuid: string, year: number) => {
        try {
            set({ loading: true });

            const response = await CifaAPI.getByInstitutionAndYear(institution_uuid, year);
            set({ cifa: response.dados, loading: false });
            return true;
        } catch (error) {
            set({ loading: false });
            throw error;
        }
    },
    setLoading: (loading: boolean) => set({ loading }),

    setPartialForm: (chave: keyof ICifaForm, valor: any) => {
        console.log(chave, valor);
        set((state) => ({
            cifa: {
                ...state.cifa,
                [chave]: valor
            }
        }))
    },
}));

export default useCifaStore;